import { useSelector } from "react-redux";
import { Modal, Image, Button } from "semantic-ui-react";
import sampleIDImage from '../../../resources/sampleIDImage.png';


const Info = ({ handleInfoModalClose, infoType }) => {

    const privacyPolicyDocumentLink = useSelector(state => state?.partnerID?.privacyPolicyDocumentLink)
    const generalTermsOFUseLink = useSelector(state => state?.partnerID?.generalTermsOFUseLink)

    return (
        <>
            <Modal.Content>
                {infoType === "imageGuidelines" && (
                    <>
                        <p><strong>Profile Image Upload Guidelines:</strong></p>
                        <ul>
                            <li><strong>Allowed Formats:</strong> JPEG (.jpg), PNG (.png) (Max size: 5MB)</li>
                            <li><strong>Recommended Size:</strong> 1024x1024 pixels for best quality</li>
                            <li><strong>Face Visibility:</strong> The image should be clear, showing your entire face—no blurriness</li>
                            <li><strong>Centering & Lighting:</strong> Ensure your face is centered with proper lighting—avoid shadows</li>
                            <li><strong>No Overlays:</strong> Do not include logos, text, or watermarks in the image</li>
                            <li><strong>Background:</strong> Use a simple, plain background—no distractions</li>
                        </ul>
                        <div style={{ marginTop: '20px', textAlign: 'center' }}>
                            <p><strong>Sample Image:</strong></p>
                            <Image src={sampleIDImage} size='small' centered />
                        </div>
                        <p style={{ marginTop: '10px', textAlign: 'center' }}>
                            Follow the sample to ensure a professional-looking profile image.
                        </p>
                    </>
                )}

                {infoType === "privacyPolicy" && (
                    <div>
                        {privacyPolicyDocumentLink ? (
                            <iframe
                                src={privacyPolicyDocumentLink}
                                width="100%"
                                height="600px"
                                title="Privacy Policy"
                                style={{ border: 'none' }}
                                onError={() => alert("Failed to load the Privacy Policy document. Please try again later.")}
                            ></iframe>
                        ) : (
                            <div style={{ color: 'red', textAlign: 'center', padding: '20px' }}>
                                Privacy Policy document is not available at the moment.
                            </div>
                        )}
                    </div>
                )}


                {infoType === "generalTermOfUse" && (
                    <div>
                        {generalTermsOFUseLink ? (
                            <iframe
                                src={generalTermsOFUseLink}
                                width="100%"
                                height="600px"
                                title="General Terms of Use"
                                style={{ border: 'none' }}
                                onError={() => alert("Failed to load the General Terms of Use document. Please try again later.")}
                            ></iframe>
                        ) : (
                            <div style={{ color: 'red', textAlign: 'center', padding: '20px' }}>
                                General Terms of Use document is not available at the moment.
                            </div>
                        )}
                    </div>
                )}


            </Modal.Content>
            <Modal.Actions>
                <Button color='blue' onClick={() => handleInfoModalClose()}>
                    Got it!
                </Button>
            </Modal.Actions>
        </>
    );
}

export default Info;
